import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { createBrowserHistory } from 'history';
import createRootReducer from './reducer';
import { isEnvDev } from './utils/env';

const isDev = isEnvDev();

export const history = createBrowserHistory();

const middleware = applyMiddleware(thunk);

const devTools =
  // eslint-disable-next-line no-underscore-dangle
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f;

export default initialState =>
  createStore(
    createRootReducer(),
    initialState,
    ...[
      isDev ?
        compose(
          middleware,
          devTools
        ) :
        middleware
    ]
  );
